import { useState, useEffect, useRef } from "react";

const useDataFetchFunction = () => {
  const [response, setResponse] = useState([]);
  const [fetchData, setFetchData]= useState(null)
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [controller, setController] = useState();

  
  // Create a ref to store the AbortController instance
  // const controllerRef = useRef(null);

  const axiosFetch = async (configObj) => {
    const { axiosInstance, method, url, requestConfig = {} } = configObj;

    // If there's an ongoing request, abort it
    // if (controllerRef.current) {
    //   controllerRef.current.abort();
    // }

    // Create a new AbortController for this request
    // const ctrl = new AbortController();
    // controllerRef.current = ctrl;

    try {
      setLoading(true);
      const ctrl = new AbortController();
      setController(ctrl);
      const res = await axiosInstance[method.toLowerCase()](url, {
        ...requestConfig,
        signal: ctrl.signal,
      });
      setResponse(res.data);
      setFetchData(res)
      setError(""); // Clear any previous error
    } catch (err) {
      if (err.name !== "AbortError") {
        console.log("fetchErr", err);
        setError(err.message);
        setFetchData(err)
      }
    } finally {
      setLoading(false);
    }
  };

  const resetPostResponse = () => {
    setResponse([]);
    setError("");
    setLoading(false);
    setFetchData(null)
  };

  useEffect(() => {
    // Cleanup when the component unmounts
    return () => {
      return () => controller && controller.abort();

    };
  }, [controller]);

  return [response, error, loading, axiosFetch, fetchData, resetPostResponse];
};

export default useDataFetchFunction;